export enum FileActionType {
  SaveOnly = 'saveOnly',
  StartTask = 'startTask',
  Distribute = 'distribute',
  Route = 'route',
  Cancel = 'cancel'
}
